import { render, staticRenderFns } from "./PendingFamilyHubModal.vue?vue&type=template&id=002a3a1c&scoped=true&"
import script from "./PendingFamilyHubModal.vue?vue&type=script&lang=ts&"
export * from "./PendingFamilyHubModal.vue?vue&type=script&lang=ts&"
import style0 from "./PendingFamilyHubModal.vue?vue&type=style&index=0&id=002a3a1c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a3a1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VCol,VOverlay,VRow,VSpacer})
